import { createSelector } from 'reselect';
import { getCurrentState } from 'src/modules/routing/selectors/getCurrentState';

export const getCurrentMatch = createSelector([
  getCurrentState,
], (state) => state?.match ?? null);
